import {LandTile} from '#/components/land/land-tile';
import {useCoinDisplayPreferences} from '#/hooks/use-coin-display-preferences';
import {useSelectedLand} from '#/hooks/use-selected-land';
import {FunctionComponent} from 'react';
import {Land, LandMarketInfo} from 'shareland-common';

export const LandsGrid: FunctionComponent<{
  landAndInfos: {land: Land; landMarketInfo: LandMarketInfo | undefined}[];
  onLandClick: (land: Land, landMarketInfo?: LandMarketInfo) => void;
}> = ({landAndInfos, onLandClick}) => {
  const {data: selectedLand} = useSelectedLand();

  const displayPref = useCoinDisplayPreferences();

  return (
    <div className={'grid auto-rows-homeGrid grid-cols-homeGrid gap-4'}>
      {landAndInfos.map(({land, landMarketInfo}, index) => (
        <LandTile
          key={`all-locations-land-tile-${index}`}
          selected={!!selectedLand && selectedLand.id === land?.id}
          className={`row-span-3 ${getRowSpanFromIndex(index)}`}
          land={land}
          landMarketInfo={landMarketInfo}
          onLand={onLandClick}
          displayPref={displayPref}
        />
      ))}
    </div>
  );
};

const repeatEffectAtEveryRow = 3;

const getRowSpanFromIndex = (index: number) => {
  if (index % repeatEffectAtEveryRow === 0) return 'md:row-span-5';
  if (index % repeatEffectAtEveryRow === 1) return 'md:row-span-4';
  return 'md:row-span-3';
};
